import React, { FC, ReactNode } from 'react';

import { Typography } from '@mui/material';
import ReactMarkdown, { defaultUrlTransform } from 'react-markdown';

import { MarkdownTextType } from '@/components/DynamicForm/types/DynamicFormTypes';
import { flattenIntoKey } from '@/components/DynamicForm/utils/utils';

interface HeadingProps {
	children?: ReactNode;
}

const Heading1: FC<HeadingProps> = ({ children }) => <Typography variant="header1">{children}</Typography>;
const Heading2: FC<HeadingProps> = ({ children }) => <Typography variant="header2">{children}</Typography>;
const Heading3: FC<HeadingProps> = ({ children }) => <Typography variant="header3">{children}</Typography>;
const Heading4: FC<HeadingProps> = ({ children }) => <Typography variant="header4">{children}</Typography>;

const MarkdownText: React.FC<Pick<MarkdownTextType, 'text' | 'variant' | 'textAlign' | 'tagData'>> = ({
	text,
	variant,
	textAlign,
	tagData,
}) => {
	return (
		<Typography
			{...flattenIntoKey(tagData, 'data')}
			variant={variant || 'mainNavigationLight'}
			textAlign={textAlign}
		>
			<ReactMarkdown
				urlTransform={(url) => (url.startsWith('tel:') ? url : defaultUrlTransform(url))}
				components={{
					h1: Heading1,
					h2: Heading2,
					h3: Heading3,
					h4: Heading4,
				}}
			>
				{text}
			</ReactMarkdown>
		</Typography>
	);
};

export default MarkdownText;
